import { ResortInsightsService } from "./resort-insights.service";
import { TealiumService } from "./tealium/tealium.service";
import { Utilities } from "../shared/utilities";
import { ResortPageViews } from "./resort-custom-events";
import { ApplicationConfiguration, Member, IApplication } from "../shared/core/ovs.core";
import { MemberProperties, DisplayOptionsProperties } from "./tealium/tealium-data-points.model";
import { ResortApplicationConfiguration, ResortSummary, ResortDetail, ResortInventory, ResortBooking } from "../models/presentation.model";
import { ResortRegisterTealiumPage, ResortRegisterTealiumEvent } from 'marketing-tealiumhub';


export class UserActivityDataContainer {
    public configuration: ResortApplicationConfiguration;
    public member: Member;
    public searchCriteria: SearchCriteria;
    public searchResults: ResortSummary[];
    public resortDetail: ResortDetail;
    public inventory: ResortInventory;
    public booking: ResortBooking;
    public agentInfo: AgentInfo;
}

export enum UserActivityPublishDataTypes {
    ApplicationConfiguration,
    SearchCriteria,
    SearchResults,
    ResortDetail,
    Inventory,
    Booking,
    AgentInfo,
    Member
}

export class SearchCriteria {
    searchText: string;
    city: string;
    state: string;
    country: string;
    selectedDate: Date;
    latitude: number;
    longitude: number;
    searchId: string;
    searchFilter: string;
}

export class AgentInfo {

    agent_email: string;
    agent_first_name: string;
    agentFullName: string;
    agent_assist_date: string;
    agent_last_name: string;
    agent_phone: string;
    agent_id: string;

}

export class UserActivityLogger {

    private static publishedData: UserActivityDataContainer = new UserActivityDataContainer();

    static getPublishedData(): UserActivityDataContainer {
        return this.publishedData;
    }

    static publish(obj: any, dataType: UserActivityPublishDataTypes) {
        switch (dataType) {
            case UserActivityPublishDataTypes.Member:
                this.publishedData = Utilities.merge(this.publishedData, { 'member': obj as Member });
                break;
            case UserActivityPublishDataTypes.ApplicationConfiguration:
                this.publishedData = Utilities.merge(this.publishedData, { 'configuration': obj as ResortApplicationConfiguration });
                break;
            case UserActivityPublishDataTypes.SearchCriteria:
                this.publishedData = Utilities.merge(this.publishedData, { 'searchCriteria': obj as SearchCriteria });
                break;
            case UserActivityPublishDataTypes.SearchResults:
                this.publishedData = Utilities.merge(this.publishedData, { 'searchResults': obj as ResortSummary });
                break;
            case UserActivityPublishDataTypes.ResortDetail:
                this.publishedData = Utilities.merge(this.publishedData, { 'resortDetail': obj as ResortDetail });
                break;
            case UserActivityPublishDataTypes.Inventory:
                this.publishedData = Utilities.merge(this.publishedData, { 'inventory': obj as ResortInventory });
                break;
            case UserActivityPublishDataTypes.Booking:
                this.publishedData = Utilities.merge(this.publishedData, { 'booking': obj as ResortBooking });
                break;
            case UserActivityPublishDataTypes.AgentInfo:
                this.publishedData = Utilities.merge(this.publishedData, { 'agentInfo': obj as AgentInfo });
                break;
        }
    }

    static logEvent(eventName: string,
        eventData: any,
        options: UserActivityLoggerOptions = UserActivityLoggerOptions.Both) {
        try {
            switch (options) {
                case UserActivityLoggerOptions.AppInsightsOnly:
                    ResortInsightsService.logEvent(eventName, eventData);
                    break;

                case UserActivityLoggerOptions.TealiumOnly:
                    ResortRegisterTealiumEvent(this.generateTealiumEventArgs(eventName, eventData));
                    break;

                case UserActivityLoggerOptions.Both:
                default:
                    ResortInsightsService.logEvent(eventName, eventData);
                    ResortRegisterTealiumEvent(this.generateTealiumEventArgs(eventName, eventData));
                    break;
            }
        } catch (e) {
            console.log("UserActivityLogger.logEvent Failed on:" + eventName + " options:" + options);
        }
    }

    static logPageView(pageName: string, options: UserActivityLoggerOptions = UserActivityLoggerOptions.Both, data?: any) {
        try {
            switch (options) {

                case UserActivityLoggerOptions.AppInsightsOnly:
                    ResortInsightsService.logPageView(pageName, this.publishedData, data);
                    break;

                case UserActivityLoggerOptions.TealiumOnly:
                    ResortRegisterTealiumPage(pageName, this.publishedData, data);
                    break;

                case UserActivityLoggerOptions.Both:
                    ResortInsightsService.logPageView(pageName, this.publishedData, data);
                    ResortRegisterTealiumPage(pageName, this.publishedData, data);
                    break;
                default:
                    break;

            }
        } catch (e) {
            console.log("UserActivityLogger.logPageView Failed on:" + pageName + " options:" + options);
        }
    }

    private static generateTealiumEventArgs(eventName, eventData) {
        return Utilities.merge({ "event_name": eventName }, eventData);
    }
}


export enum UserActivityLoggerOptions {
    Both,
    AppInsightsOnly,
    TealiumOnly,
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/instrumentation/user-activity-logger.service.ts